<div class="content-wrapper">
  @if (vehicleGroups()) {
    <mat-card class="content">
      <div class="content-header">
        <h2>
          Alle voertuiggroepen
          <span>({{ totalVehicleGroups() }})</span>
        </h2>
        <mat-form-field class="mat-form-field-no-subscript">
          <mat-label>Zoeken</mat-label>
          <input matInput autocomplete="off" placeholder="Zoeken" [formControl]="searchCtrl" />
          <button
            mat-icon-button
            matSuffix
            aria-label="Zoekopdracht wissen"
            (click)="clearSearch(); $event.stopPropagation()"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <mat-table mat-table #table [dataSource]="filteredVehicleGroups()">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Naam</mat-header-cell>
          <mat-cell *matCellDef="let vehicleGroup">
            @if (vehicleGroup.name) {
              <p class="text-truncate">
                {{ vehicleGroup.name }}
              </p>
            }
          </mat-cell>
        </ng-container>
        <!-- color Column -->
        <ng-container matColumnDef="color">
          <mat-header-cell *matHeaderCellDef>Kleur</mat-header-cell>
          <mat-cell *matCellDef="let vehicleGroup">
            <div class="color-dot" [ngStyle]="{ 'background-color': vehicleGroup.color }"></div>
            <p class="phone text-truncate">
              {{ vehicleGroup.color }}
            </p>
          </mat-cell>
        </ng-container>
        <!-- button Column -->
        <ng-container matColumnDef="button">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let vehicleGroup">
            <div class="buttons">
              <button mat-icon-button aria-label="Voertuiggroep bewerken">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                aria-label="Voertuiggroep verwijderen"
                (click)="deleteItem(vehicleGroup); $event.stopPropagation()"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let vehicleGroup; columns: displayedColumns"
          class="user"
          role="button"
          tabindex="0"
          aria-label="Voertuiggroep openen"
          (click)="editItem(vehicleGroup)"
          (keydown.enter)="editItem(vehicleGroup)"
          (keydown.space)="$event.preventDefault(); editItem(vehicleGroup)"
          matRipple
        ></tr>
      </mat-table>
    </mat-card>
  } @else {
    <div class="content-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
